import {
    TEAM_APPLY_JOB_LIST2_REQUEST, TEAM_APPLY_JOB_LIST2_FAIL, TEAM_APPLY_JOB_LIST2_SUCCESS
  } from "../constants/AuthConstant";
  
  const initialState = {
    //  loading: false,
    action: "Job Action",
    result: [],
    msg: "",
    error: "",
  };
  
  const TeamApplyJobListReducer = (state = initialState, action) => {
    switch (action.type) {
      case TEAM_APPLY_JOB_LIST2_REQUEST:
        return {
          ...state,
          //  loading: action.payload,
        };
      case TEAM_APPLY_JOB_LIST2_SUCCESS:
        return {
          ...state,
          result: action.result.data,
          //  loading: action.payload,
          msg: action.msg,
        };
      case TEAM_APPLY_JOB_LIST2_FAIL:
        return {
          ...state,
          error: action.error,
          //  loading: action.payload,
          msg: action.msg,
        };
  
      default:
        return state;
    }
  };
  
  export default TeamApplyJobListReducer;
  